import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Allowances } from '@frontend/containers/Allowances';
import React from 'react';

var AllowancesPage = function AllowancesPage() {
  return _jsx(Allowances, {});
};

export var __N_SSG = true;
export default AllowancesPage;